import React, { useEffect, useMemo, useState } from 'react';
import * as styles from './HomeV3.module.scss';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import RedNumberText from '../../../components/RedNumberText/RedNumberText';
import LinkCardV2 from '../../../components/LinkCard/V2/LinkCardV2';
import { formatIncrementedValue, formatLinks } from '../helpers';

const HomeV2 = ({ pageContext }) => {
  const [subheader, setSubheader] = useState(
    formatIncrementedValue(pageContext.data.V2_Subheader)
  );

  const initialLinks = useMemo(() => formatLinks(pageContext), [pageContext]);
  const [links, setLinks] = useState(initialLinks);

  const [scrollOpacity, setScrollOpacity] = useState(1);
  const [headerOpacity, setHeaderOpacity] = useState(0);

  const avatarImage = useMemo(
    () =>
      getImage(
        pageContext.data.Cover_Photo_Desktop?.localFiles?.[0]?.childImageSharp
      ),
    [pageContext.data.Cover_Photo_Desktop]
  );

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      const maxScroll = 312;

      const newScrollOpacity = Math.max(0, 1 - scrollPosition / maxScroll);
      const newHeaderOpacity = Math.min(1, scrollPosition / maxScroll);

      setScrollOpacity(newScrollOpacity);
      setHeaderOpacity(newHeaderOpacity);
    };

    window.addEventListener('scroll', handleScroll);

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const timeout1 = setTimeout(() => {
      setLinks(formatLinks(pageContext, -1));
      setSubheader(formatIncrementedValue(pageContext.data.V2_Subheader, -1));
    }, 1 * 1000);

    const timeout2 = setTimeout(() => {
      setLinks(formatLinks(pageContext, -2));
      setSubheader(formatIncrementedValue(pageContext.data.V2_Subheader, -2));
    }, 3 * 1000);

    return () => {
      clearTimeout(timeout1);
      clearTimeout(timeout2);
    };
  }, []);

  return (
    <div className={styles.container}>
      <div className={styles.backgroundImageContainer}>
        {avatarImage && (
          <GatsbyImage
            image={avatarImage}
            alt="Background Image"
            className={styles.backgroundImage}
          />
        )}
      </div>

      <div
        className={styles.mainCard}
        style={{
          backgroundColor: !pageContext.data.V2BackgroundImage
            ? pageContext.data.V2BackgroundColor ?? '#33aa331a'
            : 'transparent',
        }}
      >
        <div
          className={styles.profileHeader}
          style={{ opacity: headerOpacity }}
        >
          <div className={styles.profileHeaderAvatarAndName}>
            <div className={styles.profileHeaderAvatar}>
              {avatarImage && (
                <GatsbyImage
                  image={avatarImage}
                  alt="Cover Photo Mobile"
                  className={styles.profileHeaderAvatar}
                />
              )}
            </div>

            {pageContext.data.Full_Name}
          </div>
        </div>

        <div className={styles.content}>
          <div className={styles.rootProfilePhotoContainer}>
            <div
              className={styles.profilePhotoContainer}
              style={{ opacity: scrollOpacity }}
            >
              {avatarImage && (
                <GatsbyImage
                  image={avatarImage}
                  alt="Cover Photo Mobile"
                  className={styles.profilePhoto}
                />
              )}
            </div>
          </div>

          <div className={styles.scrollView}>
            <div className={styles.profileDetails}>
              <div className={styles.profileDetailsContent}>
                <h1 className={styles.profileName}>
                  {pageContext.data.Full_Name}
                </h1>

                <span className={styles.profileSlug}>
                  @{pageContext.data.Name}
                </span>
              </div>
            </div>

            <div className={styles.scrollGroup}>
              <h2 className={styles.profileSubHeader}>
                <RedNumberText {...subheader} />
              </h2>

              <div className={styles.linksList}>
                {links.map((linkData) => (
                  <LinkCardV2 key={linkData.link} linkData={linkData} />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomeV2;
